document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-menu-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var menu = document.getElementById(button.getAttribute('aria-controls'));
      var open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (menu) menu.hidden = open;
    });
  });
});
